var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,12c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5Zm5.5,1h-1.08c-.44,3.06-2.86,5.48-5.92,5.92v1.08h-2v-1.08c-3.06-.44-5.48-2.86-5.92-5.92h-1.08v-2h1.08c.44-3.06,2.86-5.48,5.92-5.92v-1.08h2v1.08c3.06,.44,5.48,2.86,5.92,5.92h1.08v2Zm-3-1c0-2.76-2.24-5-5-5s-5,2.24-5,5,2.24,5,5,5,5-2.24,5-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentLocation);
export default __webpack_public_path__ + "static/1769707387/media/icon-current-location.1d00fe36c2cc9a4a1113a69a11e3cdf6.svg";
export { ForwardRef as ReactComponent };